import { useQuery } from "react-query";
import { RestError } from "../../../services/rest-service/RestService";
import SummaryListingDataService from "../../../services/summary-listing-data-service/SummaryListingDataService";
import { ITankBatterySummaryGridModel } from "../../../services/summary-listing-data-service/TankBatterySummaryModels";
import { BaseUseQueryParameters } from "../../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseTankBatterySummaryDataParameters = {
    customerID: number,
    groupID: number,
    configurationID?: number
} & BaseUseQueryParameters<ITankBatterySummaryGridModel>;

export function useTankBatterySummaryData({
    customerID,
    groupID,
    offline,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseTankBatterySummaryDataParameters) {
    return useQuery<ITankBatterySummaryGridModel, RestError>(
        keys.summaryData(customerID, groupID, offline ?? false),
        ({ signal }) => {
            return SummaryListingDataService.getTankBatteryData(customerID, groupID, false, offline ?? false, signal);
        },
        {
            enabled,
            onError,
            onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds * 1000 : false
        }
    );
}
